import { formatLabel, optionsHorizontalBar } from "./utils"

const cd_training_region = {
  figureNumber: "2.5",
  title: "Participant Income Group",
  subTitle: "FY 2022 (number of participants)",
  source: "Sources: IMF, Participant and Applicant Tracking System; and IMF staff calculations. /n Note: Most of the IMF’s training falls under the Institute for Capacity Development (ICD) Training Program, which includes training coordinated by ICD and delivered by ICD and other departments at IMF headquarters and globally at the IMF’s Regional Capacity Development Centers and in programs for country officials. Training also includes IMF online courses successfully completed by country officials. In addition, training is provided by functional departments outside the ICD Training Program.",
  data: {
    labels: [
      formatLabel("Sub-saharan Africa", 30),
      formatLabel("Western Hemisphere", 30),
      formatLabel("Asia and Pacific", 30),
      formatLabel("Middle East and Central Asia", 30),
      formatLabel("Europe", 30),
    ],
    datasets: [
      {
        label: "",
        data: [6480, 5892, 5830, 3386, 1480],
        backgroundColor: "#008FC4",
      },
    ],
  },
  options: optionsHorizontalBar,
}

export default cd_training_region;